module.exports = __webpack_public_path__ + "a3fe58dd11790a5c228c61852b228f34.svg";